export default __webpack_public_path__ + "static/and-case-3-610dca2ce2b4960321c3723dfbbe85b4.webp";